import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Container } from '@mui/material'
import Loader from '../../shared/ui/Loader'

const MinimalLayout = () => {
  return (
    <Container component="main" sx={{ pt: 4, pb: 4 }}>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </Container>
  )
}

export default MinimalLayout
